import React  from "react";

const Mapview = () => {
    return (
        <div>
            <h1>Mapview</h1>
        </div>
    )
}

export default Mapview